import { organisationConstants } from '../../_constants/organisation.constants';

const initialState = { update_min_res_loading : true, update_min_res: '', update_min_res_error: false};

export function updateMinRespondence(state = initialState, action) {
    switch (action.type) {
      case organisationConstants.REQUEST_UPDATE_MIN_RES:
        return {
            update_min_res_loading: true,
            update_min_res: '',
            update_min_res_error: false
        };
      case organisationConstants.RECEIVE_UPDATE_MIN_RES:
        return {
            update_min_res_loading: false,
            update_min_res: action.update_min_res,
            update_min_res_error: false
        };
      case organisationConstants.ERROR_UPDATE_MIN_RES:
        return { 
            update_min_res_loading: false,
            update_min_res: '',
            update_min_res_error: true
        };
      default:
        return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/organisation/updateMinResp.reducer.js